<!--
  Reiner Story-INHALT (Titel, Maskottchen-Hero, Team-Matchup, Quoten horizontal, Bericht-Text,
  Tipp-Box) - OHNE Overlay-Chrome (kein Sheet-Griff, kein Schließen-Button). Wiederverwendbar
  sowohl im eigenständigen BetmanStoryDetail.vue (dediziertes Overlay mit Drag-to-Dismiss) als
  auch im "vorschau"-Tab des generischen DetailOverlay.vue - damit beide Stellen exakt gleich
  aussehen, statt zwei unterschiedliche Darstellungen für dieselbe Story zu haben.

  Layout-Update: Betman-Bild jetzt als große, prominente Hero-Grafik (volle Breite) mit dem
  BETMAN-Badge als Stempel direkt AUFS Bild statt als eigene Zeile - darunter Team-Matchup mit
  Logos, dann Quoten horizontal (statt gestapelt), dann eine unauffällige Meta-Zeile
  (Anstoßzeit + Erstellt-Datum zusammen, klein).
-->
<template>
  <div class="betman-story-body">
    <h2 v-if="zeigeTitel" class="betman-detail-overlay__titel">{{ story.titel }}</h2>

    <div v-if="story.imageUrl" class="betman-detail-overlay__hero">
      <div class="betman-detail-overlay__hero-sub">
        <img :src="story.imageUrl" class="betman-detail-overlay__maskottchen" alt="Bet-Man" />
        <span class="betman-detail-overlay__badge betman-detail-overlay__badge--stempel">BETMAN</span>
      </div>
    </div>

    <div v-if="story.heim || story.auswaerts" class="betman-detail-overlay__matchup">
      <div class="betman-detail-overlay__team">
        <img v-if="heimLogo" :src="heimLogo" class="betman-detail-overlay__team-logo" alt="" />
        <span class="betman-detail-overlay__team-name">{{ story.heim }}</span>
      </div>
      <span 
        class="betman-detail-overlay__matchup-trenner"
        :class="{ 'betman-detail-overlay__matchup-trenner--ergebnis': ergebnisFormatiert }"
      >{{ ergebnisFormatiert || '–' }}</span>
      <div class="betman-detail-overlay__team betman-detail-overlay__team--auswaerts">
        <span class="betman-detail-overlay__team-name">{{ story.auswaerts }}</span>
        <img v-if="auswaertsLogo" :src="auswaertsLogo" class="betman-detail-overlay__team-logo" alt="" />
      </div>
    </div>

    <div v-if="hatQuoten" class="betman-detail-overlay__quoten">
      <div :class="['betman-detail-overlay__quote-box', { 'betman-detail-overlay__quote-box--beste': besteQuote === '1' }]">
        <span class="betman-detail-overlay__quote-label">Heim</span>
        <span class="betman-detail-overlay__quote-wert">{{ story.quote_1 }}</span>
      </div>
      <div :class="['betman-detail-overlay__quote-box quote-box-x', { 'betman-detail-overlay__quote-box--beste': besteQuote === 'X' }]">
        <span class="betman-detail-overlay__quote-label">Remis</span>
        <span class="betman-detail-overlay__quote-wert">{{ story.quote_X }}</span>
      </div>
      <div :class="['betman-detail-overlay__quote-box', { 'betman-detail-overlay__quote-box--beste': besteQuote === '2' }]">
        <span class="betman-detail-overlay__quote-label">Auswärts</span>
        <span class="betman-detail-overlay__quote-wert">{{ story.quote_2 }}</span>
      </div>
    </div>

    <!--
    <span v-if="ergebnisFormatiert" class="betman-detail-overlay__ergebnis">Endstand: {{ ergebnisFormatiert }}</span>
    -->

    <!-- Anstoßzeit + Erstellt-Datum jetzt in EINER unauffälligen Zeile statt zwei separaten,
         prominenten Zeilen - der Nutzer soll wissen, wann's erstellt wurde, aber es tritt
         optisch klar hinter Bild/Matchup/Quoten zurück. GEÄNDERT: timeMatch nur bei
         tatsächlichem Match-Bezug zeigen (story.heim/auswaerts vorhanden, gleiche Prüfung wie
         bei der Matchup-Zeile oben) - bei matchlosen Storys (Transfer/Verletzung/etc.) reicht
         das Erstellt-Datum allein, eine Anstoßzeit ohne Match ergibt da keinen Sinn. -->
    <div v-if="(story.heim && story.timeMatch) || erstelltAmFormatiert" class="betman-detail-overlay__meta-zeile">
      <span v-if="story.heim && story.timeMatch">{{ story.timeMatch }}</span>
      <span v-if="story.heim && story.timeMatch && erstelltAmFormatiert"> · </span>
      <span v-if="erstelltAmFormatiert">erstellt {{ erstelltAmFormatiert }}</span>
    </div>

    <p class="betman-detail-overlay__text">{{ story.bericht || story.text }}</p>

    <!-- NEU: "Meine Einschätzung" (betman_einschaetzung) - persönliche Nachbetrachtung/
         Bauchgefühl, kommt direkt aus dem imageBetman-JSON, wie betman_tipp. -->
    <div v-if="story.betman_einschaetzung" class="betman-detail-overlay__einschaetzung">
      <h3 class="betman-detail-overlay__einschaetzung-titel">Meine Einschätzung</h3>
      <p class="betman-detail-overlay__einschaetzung-text">{{ story.betman_einschaetzung }}</p>
    </div>

    <!-- GEÄNDERT: betmanTipp (camelCase) -> betman_tipp (snake_case, so wie es tatsächlich aus
         dem imageBetman-JSON kommt) - Namens-Mismatch war der Grund, warum der Tipp bisher
         nie angezeigt wurde. -->
    <div v-if="story.zeigeTipp && story.betman_tipp" class="betman-detail-overlay__tipp-box">
      <span class="betman-detail-overlay__tipp-icon">🎯</span>
      <div>
        <div class="betman-detail-overlay__tipp-label">Betman tippt:</div>
        <div class="betman-detail-overlay__tipp-text">{{ story.betman_tipp }}</div>
      </div>
    </div>

    <!-- Kommt aus imageBetman-JSON (parseStoryJson merged alles flach rein) - noch nicht immer
         vorhanden (Feld wird laut Ankündigung erst in Zukunft befüllt), deshalb rein defensiv
         mit v-if geprüft, kein Fehler falls (noch) nicht da. -->
    <div v-if="story.tippAuswertung" class="betman-detail-overlay__tipp-box betman-detail-overlay__tipp-box--auswertung">
      <span class="betman-detail-overlay__tipp-icon">📊</span>
      <div>
        <div class="betman-detail-overlay__tipp-label">Tipp-Auswertung:</div>
        <div class="betman-detail-overlay__tipp-text">{{ story.tippAuswertung }}</div>
      </div>
    </div>
  </div>
  <nav v-if="zeigeSchnellLinks" class="betman-detail-overlay__links" aria-label="Weitere Berichte">
    <a
      v-for="l in schnellLinks"
      :key="l.href"
      :href="l.href"
      target="_blank"
      rel="noopener"
      class="betman-detail-overlay__link"
    >{{ l.text }}</a>
  </nav>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  story: { type: Object, required: true },
  // Erwartete Felder: titel, bericht/text, imageUrl, timeMatch, quote_1, quote_X, quote_2,
  // heim, auswaerts, betmanTipp, zeigeTipp

  // Steuert, ob der eigene <h2>-Titel gezeigt wird - im eigenständigen BetmanStoryDetail.vue
  // (kein anderer Titel vorhanden) bleibt's bei true; im generischen DetailOverlay.vue zeigt
  // dessen EIGENE Kopfzeile (.tm-detail-overlay__titel) schon den Story-Titel - dort auf false
  // setzen, sonst erscheint der Titel doppelt.
  zeigeTitel: { type: Boolean, default: true },

  // Nur für Spielbericht relevant - kommt vom MATCH, nicht aus der Story selbst, deshalb als
  // eigene Props statt Teil von story.
  heimtore: { type: Number, default: null },
  austore: { type: Number, default: null },
  // NEU: Team-Logos fürs Matchup - kommen ebenfalls vom MATCH (match.heimLogo/auswaertsLogo),
  // die Story selbst hat keine eigenen Logo-Felder. Optional, Matchup-Zeile zeigt einfach nur
  // den Namen ohne Logo, falls (noch) nicht übergeben.
  heimLogo: { type: String, default: null },
  auswaertsLogo: { type: String, default: null },
  // Schnell-Links zu den Kategorien am Ende - nur im eigenständigen Story-Overlay an
  zeigeSchnellLinks: { type: Boolean, default: false }
})

const BASIS = 'https://app.team-match.io'
const schnellLinks = [
  { text: 'Vorberichte', href: `${BASIS}/match-vorschau/` },
  { text: 'Spielberichte', href: `${BASIS}/spielbericht/` },
  { text: 'Stories', href: `${BASIS}/fussball-story/` }
]

const hatQuoten = computed(() =>
  props.story.quote_1 != null && props.story.quote_X != null && props.story.quote_2 != null
)

const ergebnisFormatiert = computed(() => {
  if (props.heimtore == null || props.austore == null) return ''
  return `${props.heimtore}:${props.austore}`
})

// Niedrigster Quoten-Wert = Favorit (höchste implizite Wahrscheinlichkeit lt. Buchmacher) - wird
// grün hervorgehoben, analog zum bestehenden Muster in MatchCard (.tm-quote-zeile__wert--favorit).
const besteQuote = computed(() => {
  if (!hatQuoten.value) return null
  const werte = { '1': Number(props.story.quote_1), 'X': Number(props.story.quote_X), '2': Number(props.story.quote_2) }
  return Object.entries(werte).reduce((a, b) => (b[1] < a[1] ? b : a))[0]
})

// createdAt kommt vermutlich als ISO-String oder Timestamp vom Server - defensiv parsen und im
// selben Stil wie timeMatch anzeigen (TT.MM.JJJJ HH:mm). Bei unbekanntem/nicht parsbarem Format
// einfach nichts anzeigen (kein kaputtes "Invalid Date" im UI).
const erstelltAmFormatiert = computed(() => {
  if (!props.story.createdAt) return ''
  // GEÄNDERT: siehe BetmanStoryCardErweitert.vue - createdAt kommt ohne Zeitzonen-Kennzeichnung,
  // meint aber UTC. Explizit als UTC parsen, damit new Date() korrekt in die lokale Zeitzone umrechnet.
  const isoUtc = props.story.createdAt.replace(' ', 'T') + (props.story.createdAt.endsWith('Z') ? '' : 'Z')
  const datum = new Date(isoUtc)
  if (Number.isNaN(datum.getTime())) return ''
  const pad = (n) => String(n).padStart(2, '0')
  return `${pad(datum.getDate())}.${pad(datum.getMonth() + 1)}.${datum.getFullYear()} ${pad(datum.getHours())}:${pad(datum.getMinutes())}`
})
</script>